import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Renderer_SurveyComponentBase.scss';
import { _className, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
export class Renderer_SurveyComponentBase extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.question = nextProps.question;
        state.currentValue = nextProps.currentValue;
        return state;
    }
    renderQuestion = () => {
        return _jsx("div", { className: 'question-label', children: this.state.question.label });
    };
    render() {
        return _jsxs(LL_V_L, { className: _className('survey-component', this.componentType), children: [this.renderQuestion(), this.renderInput()] });
    }
}
//# sourceMappingURL=Renderer_SurveyComponentBase.js.map